<template>
 <div>
   <div class="addExperiment-title">
      <span @click="goRouter('/college')"
        >学院管理&nbsp;&nbsp; / &nbsp;&nbsp;</span
      >
      <i>学生管理</i>
    </div>
    <div v-loading="loading" style="background: #fff; padding: 20px">
    
    <div class="filter">
      <schooleLinkage ref="schoole"></schooleLinkage>
      <el-select
        class="fl"
        v-model="paramStudent.type"
        placeholder="请选择检索条件"
        style="width: 160px"
      >
        <el-option label="全部" :value="0"></el-option>
        <el-option label="学号" :value="1"></el-option>
        <el-option label="姓名" :value="2"></el-option>
        <el-option label="手机" :value="3"></el-option>
        <el-option label="邮箱" :value="4"></el-option>
      </el-select>
      <!-- <schooleLinkage ref="schoole"></schooleLinkage> -->
      <el-input
        class="fl"
        v-model="paramStudent.word"
        placeholder="搜索关键字"
        style="width: 200px;margin:0 10px;"
      >
        <el-button slot="append" @click="search">搜索</el-button>
      </el-input>
      <el-button type="primary" class="fl" @click="reset">重置</el-button>

      <router-link :to="`/college`">
        <el-button class="fr">返回</el-button>
      </router-link>
      <router-link :to="`/alliance/student/edit?schoolId=${schoolId}`">
        <el-button class="fr" type="primary" style="margin: 0 10px"
          >新建学生</el-button
        >
      </router-link>
      <el-button class="fr" type="primary" @click="tolead"
        >批量导入学生</el-button
      >
    </div>
    <el-table :data="studentData">
      <!-- <el-table-column prop="userName" label="用户名"></el-table-column> -->
      <el-table-column prop="licenseNo" label="学生学号"></el-table-column>
      <el-table-column prop="studentName" label="姓名"></el-table-column>
      <el-table-column prop="collegeName" label="学院"></el-table-column>
      <el-table-column prop="majorName" label="专业"></el-table-column>
      <el-table-column prop="gradeName" label="年级"></el-table-column>
      <el-table-column prop="className" label="班级"></el-table-column>
      <el-table-column prop="sex" label="性别"></el-table-column>
      <el-table-column prop="remark" label="备注信息"></el-table-column>
      <el-table-column prop="remark" label="是否禁用">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#13ce66"
            inactive-color="#ff4949"
            @change="disableStudent(scope.row)"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <div>
            <el-button type="primary" size="mini" @click="toEditPage(scope.row)"
              >编辑</el-button
            >
            <el-button type="primary" size="mini" @click="toDel(scope.row)"
              >删除</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagin">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :page-size="paramStudent.showItem"
        :current-page.sync="paramStudent.pageIndex"
        @size-change="handleSizeChange"
        @current-change="search"
      ></el-pagination>
    </div>
    <el-dialog
      title="导入学生信息"
      :visible.sync="dialogVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="600"
    >
      <el-form
        ref="formValidate"
        :model="form"
        label-width="100px"
        :rules="rule"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="高校" prop="schoolId">
              <el-select
                v-model="form.schoolId"
                @input="getSchoolChange(form.schoolId, 'reset')"
                disabled
              >
                <el-option
                  v-for="item in schoolData"
                  :key="item.schoolId"
                  :value="item.schoolId"
                  :label="item.schoolName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="学院" prop="collegeId">
              <el-select
                v-model="form.collegeId"
                @input="collegeChange(form.collegeId, 'reset')"
              >
                <el-option
                  v-for="item in collegeData"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="专业" prop="majorId">
              <el-select
                v-model="form.majorId"
                @input="majorChange(form.majorId, 'reset')"
              >
                <el-option
                  v-for="item in majorData"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="年级" prop="gradeId">
              <el-select
                v-model="form.gradeId"
                @input="gradeChange(form.gradeId, 'reset')"
              >
                <el-option
                  v-for="item in gradeData"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="班级" prop="classId">
              <el-select v-model="form.classId">
                <el-option
                  v-for="item in classData"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="导入模板下载">
              <el-button type="primary" size="mini" @click="download"
                >下载</el-button
              >
            </el-form-item>
            <el-form-item label="文件上传" prop="files">
              <el-button size="mini" @click="onClick">文件上传</el-button>
              <p v-if="form.files" style="line-height: 30px; margin: 0">
                {{ form.files.name }}
              </p>
              <input
                type="file"
                ref="uploadFile"
                @change="onChange"
                style="display: none"
              />
              <p
                style="
                  margin: 0px;
                  text-align: left;
                  font-size: 12px;
                  color: #8c8c8c;
                  line-height: 20px;
                "
              >
                <span>文件模板说明:</span>
                <br />education(学历) 1:高中及以下 2:大专 3:本科 4:硕士 5:博士;
                <br />sex(性别) 1:男 2:女";
              </p>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button
          type="primary"
          @click="saveSubmit('formValidate')"
          size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
  
 </div>
</template>

<script>
import schooleLinkage from "../common/schooleLinkage";
import util from "@/assets/util/util.js";

let schoolById = JSON.parse(localStorage.getItem("USER")).schoolId;
export default {
  components: { schooleLinkage },
  data() {
    return {
      classData: [], // 班级
      gradeData: [], // 年级
      majorData: [], // 专业
      schoolData: [],
      collegeData: [], // 学院
      rule: {
        schoolId: [
          {
            type: "number",
            required: true,
            message: "高校不能为空",
            trigger: "blur",
          },
        ],
        collegeId: [
          {
            type: "number",
            required: true,
            message: "请选择学院",
            trigger: "blur",
          },
        ],
        majorId: [
          {
            type: "number",
            required: true,
            message: "专业不能为空",
            trigger: "blur",
          },
        ],
        gradeId: [
          {
            type: "number",
            required: true,
            message: "年级不能为空",
            trigger: "blur",
          },
        ],
        classId: [
          {
            type: "number",
            required: true,
            message: "班级不能为空",
            trigger: "blur",
          },
        ],
        files: [
          {
            required: true,
            message: "文件不能为空",
            trigger: "blur",
          },
        ],
      },
      form: {
        files: null,
        collegeId: null, // 学院id
        schoolId: Number(schoolById), // 高校id
        majorId: null, // 专业id
        gradeId: null, // 年级
        classId: null, // 班级
      },
      // 学院参数
      paramCollege: {
        showItem: 1000,
        schoolId: schoolById,
        pageIndex: 1,
        word: "",
      },
      paramMajor: {
        collegeId: 0,
        schoolId: schoolById,
      }, // 获取专业参数
      classData: [], // 班级
      gradeData: [], // 年级
      majorData: [], // 专业
      schoolData: [],
      collegeData: [], // 学院
      dialogVisible: false,
      loading: false,
      total: 0,
      paramStudent: {
        classId: "", // 班级
        collegeId: "", // 学院id
        gradeId: "", // 年级id
        majorId: "", // 专业id
        showItem: 10,
        schoolId: schoolById, // 学校id
        pageIndex: 1,
        type: "", // 搜索条件 1:学号 2：姓名
        word: "", // 关键字 姓名或学号
      },
      schoolId: schoolById,
      schoolInfo: {},
      searchData: {
        type: 0,
        word: "",
      },
      studentData: [],
    };
  },
  methods: {
    goRouter(path) {
      this.$router.push(path);
    },
    //禁用
    disableStudent(row) {
      let params = {
        schoolId: schoolById,
        studentId: row.studentId,
        status: row.status ? 0 : 1,
      };
      this.$api.common.disableStudent(params).then((res) => {
        if (res.errCode == 0) {
          this.$message({
            message: "设置成功",
            type: "success",
          });
        } else {
          this.$message.error(res.errMsg);
        }
      });
    },
    reset() {
      this.paramStudent = {
        classId: "", // 班级
        collegeId: "", // 学院id
        gradeId: "", // 年级id
        majorId: "", // 专业id
        showItem: 10,
        schoolId: schoolById, // 学校id
        pageIndex: 1,
        type: "", // 搜索条件 1:学号 2：姓名
        word: "", // 关键字 姓名或学号
      };
      this.$refs.schoole.resetInit();
      this.search(false);
    },
    // 获取专业下年级列表
    toListPage() {
      this.$router.push({
        path: "/alliance/student",
        query: {
          schoolId: this.paramCollege.schoolId,
        },
      });
    },
    onChange() {
      this.form.files = this.$refs.uploadFile.files[0];
    },
    onClick() {
      this.$refs.uploadFile.value = "";
      this.$refs.uploadFile.click();
    },
    // 模板下载
    download() {
      this.$api.allianceSchool.downloadTemplateExcel().then((data) => {
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        util.export(blob, "学生导入");
      });
    },
    // 保存
    saveSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let formData = new FormData();
          let file = this.$refs.uploadFile.files[0];
          formData.append("files", file);
          formData.append("collegeId", this.form.collegeId);
          formData.append("schoolId", this.form.schoolId);
          formData.append("majorId", this.form.majorId);
          formData.append("gradeId", this.form.gradeId);
          formData.append("classId", this.form.classId);
          // formData.append("studentClassTO", JSON.stringify(this.form));
          this.$api.allianceSchool
            .uploadStudent(this.form, formData)
            .then((item) => {
              if (item.errCode == 0) {
                this.dialogVisible = false;
                this.search();
              } else {
                this.$message.error(item.errMsg);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 高校下拉框获取学院select
    getSchoolChange(itemID, type) {
      this.paramCollege.schoolId = itemID;
      this.$api.allianceSchool.getCollegeList(this.paramCollege).then((res) => {
        if (res.errCode == 0) {
          this.collegeData = res.data.items;
          if (type == "reset") {
            // 学院
            this.form.collegeId = null;
            // 专业
            this.form.majorId = null;
            this.majorData = [];
            // 年级
            this.form.gradeId = null;
            this.gradeData = [];
            // 班级
            this.form.classId = null;
            this.classData = [];
          }
        } else {
          this.$message.error(res.errMsg);
        }
      });
    },
    // 学院获取专业下拉框
    collegeChange(res, type) {
      this.paramMajor.collegeId = res;
      this.$api.allianceSchool.getMajorList(this.paramMajor).then((item) => {
        if (item.errCode == 0) {
          this.majorData = item.data;
          if (type == "reset") {
            // 专业
            this.form.majorId = null;
            // 年级
            this.form.gradeId = null;
            this.gradeData = [];
            // 班级
            this.form.classId = null;
            this.classData = [];
          }
        } else {
          this.$message.error(item.errMsg);
        }
      });
    },
    // 专业获取年级下拉框
    majorChange(res, type) {
      const param = {
        majorId: res,
        schoolId: this.paramCollege.schoolId,
      };
      this.$api.allianceSchool.getGradeList(param).then((item) => {
        if (item.errCode == 0) {
          this.gradeData = item.data;
          if (type == "reset") {
            // 年级
            this.form.gradeId = null;
            // 班级
            this.form.classId = null;
            this.classData = [];
          }
        } else {
          this.$message.error(item.errMsg);
        }
      });
    },
    // 获取班级
    gradeChange(res, type) {
      const param = {
        gradeId: res,
        schoolId: this.paramCollege.schoolId,
      };
      this.$api.allianceSchool.collegeMgrGetClassList(param).then((item) => {
        if (item.errCode == 0) {
          this.classData = item.data;
          if (type == "reset") {
            // 班级
            this.form.classId = null;
          }
        } else {
          this.$message.error(item.errMsg);
        }
      });
    },

    // 导入学生
    tolead() {
      this.dialogVisible = true;
    },
    handleSizeChange(val) {
      this.paramStudent.pageIndex = 1;
      this.paramStudent.showItem = val;
      this.search();
    },
    // 学院管理头部
    getSchoolInfo() {
      this.loading = true;
      this.$api.allianceSchool
        .getSchoolInfo(schoolById)
        .then((res) => {
          this.loading = false;
          if (res.errCode == 0) {
            this.schoolInfo = res.data;
          } else {
            this.$message.error(res.errMsg);
          }
        })
        .catch((res) => {
          this.loading = false;
        });
      // 获取学院列表
      const paramSchool = {
        word: "",
      };
      // 高校select
      this.$api.allianceSchool.getSchoolList(paramSchool).then((res) => {
        if (res.errCode == 0) {
          this.schoolData = res.data;
        } else {
          this.$message.error(res.errMsg);
        }
      });
    },
    // 搜索
    search(type) {
      this.loading = true;
      if (type) {
        const schooleParam = this.$refs.schoole.paramInit();
        this.paramStudent.classId = schooleParam.classId;
        this.paramStudent.collegeId = schooleParam.collegeId;
        this.paramStudent.gradeId = schooleParam.gradeId;
        this.paramStudent.majorId = schooleParam.majorId;
      }
      this.$api.allianceSchool
        .getStudentList(this.paramStudent)
        .then((res) => {
          this.loading = false;
          if (res.errCode == 0) {
            this.studentData = res.data.items;
            this.studentData.forEach((item) => {
              item.status = item.status == 0 ? true : false;
            });
            this.total = res.data.totalItems;
          } else {
            this.$message.error(res.errMsg);
          }
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    toEditPage(row) {
      this.$router.push({
        path: "/alliance/student/edit",
        query: {
          schoolId: schoolById,
          studentId: row.studentId,
        },
      });
    },
    toDel(item) {
      this.$confirm("您确认删除吗？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const param = {
          studentId: item.studentId,
          schoolId: schoolById,
        };
        this.loading = true;
        this.$api.allianceSchool
          .delStudent(param)
          .then((res) => {
            this.loading = false;
            if (res.errCode == 0) {
              this.$message.success("删除成功！");
              this.search();
            } else {
              this.$message.error(res.errMsg);
            }
          })
          .catch((res) => {
            this.loading = false;
          });
      });
    },
  },
  created() {
    this.getSchoolChange(schoolById);
    this.getSchoolInfo();
    this.search(false);
  },
};
</script>

<style lang="less" scoped>
.addExperiment-title {
    margin-bottom: 16px;
    span,i {
      font-size: 14px;
      font-family: PingFang-SC;
      font-weight: 400;
      line-height: 20px;
      color: #424346;
      opacity: 1;
      font-style: normal;
    }
    span {
      color: #939393;
      cursor: pointer;
    }
  }
.pagin {
  padding: 30px 0;
  text-align: center;
}
</style>